import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  DoneButton,
  MobileNavigationPopoverFooter,
  MobileNavigationPopoverFooterContent,
  MobileNavigationResetLink,
} from '@src/components/BottomSheet/BottomSheet.styles'

export const PopoverFooter: React.FC<{
  onCancel: () => void
  onDone: () => void
}> = ({ onCancel, onDone }) => {
  const { t } = useTranslation('serviceNavigation')
  return (
    <MobileNavigationPopoverFooter>
      <MobileNavigationPopoverFooterContent>
        <MobileNavigationResetLink onClick={onCancel}>
          {t('cancel')}
        </MobileNavigationResetLink>

        <DoneButton
          content={t('done')}
          width="180px"
          onClick={onDone}
          type={'button'}
          dataTestId="siteheader-servicenavigation-button-done"
        />
      </MobileNavigationPopoverFooterContent>
    </MobileNavigationPopoverFooter>
  )
}
